import { themeForBrickXAvenue } from '../landingPageThemes';

export default themeForBrickXAvenue;
